import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const UserRoleIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.375 13.125C5.59834 13.125 3.79982 14.4077 2.69531 16.25M12.9972 6.75C12.9972 8.40685 11.6541 9.75 9.99721 9.75C8.34036 9.75 6.99721 8.40685 6.99721 6.75C6.99721 5.09315 8.34036 3.75 9.99721 3.75C11.6541 3.75 12.9972 5.09315 12.9972 6.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.033 16.4961C14.5025 16.4961 13.9938 16.2854 13.6188 15.9103C13.2437 15.5353 13.033 15.0265 13.033 14.4961C13.033 13.9656 13.2437 13.4569 13.6188 13.0818C13.9938 12.7068 14.5025 12.4961 15.033 12.4961M15.033 16.4961C15.5634 16.4961 16.0721 16.2854 16.4472 15.9103C16.8222 15.5353 17.033 15.0265 17.033 14.4961C17.033 13.9656 16.8222 13.4569 16.4472 13.0818C16.0721 12.7068 15.5634 12.4961 15.033 12.4961M15.033 16.4961V17.9961M15.033 12.4961V10.9961M18.064 12.7461L16.765 13.4961M13.302 15.4961 12.002 16.2461M12.002 12.7461L13.302 13.4961M16.765 15.4961L18.065 16.2461"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

UserRoleIcon.displayName = 'UserRoleIcon';
